import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { Tooltip } from "@mui/material";

import MenuButton from "../MenuButton";

const ListButtons = ({ editor }) => {
	if (!editor) return null;

	return (
		<Tooltip title="Bullet List">
			<MenuButton
				isActive={editor.isActive("bulletList")}
				onClick={() => editor.chain().focus().toggleBulletList().run()}
			>
				<FormatListBulletedIcon fontSize="small" />
			</MenuButton>
		</Tooltip>
	);
};

export default ListButtons;